import { Appointment } from '@ca/common/types'
import DetailBlock from '@ui/elements/Checklist/DetailBlock'
import Loader from '@ui/elements/Loader'
import Typography from '@ui/typography'
import { leadingNone } from '@ui/typography/styles'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Platform } from 'react-native'
import Animated from 'react-native-reanimated'
import cn from '@ui/utils/cn'

interface Props {
  appointment: Appointment
  loading?: boolean
}

export default function QueueNumber({ appointment, loading }: Props) {
  const { t } = useTranslation(['common'])
  const { sequence } = appointment
  // const date = getErpDate(start_date)

  return (
    <>
      <DetailBlock>
        {!loading && (
          <Animated.View>
            <Typography
              variant="H2"
              className={cn(
                'color-text font-head-bold',
                leadingNone,
                Platform.select({
                  default: 'text-[72px]',
                  web: 'text-[6rem]',
                })
              )}
            >
              {sequence}
            </Typography>
          </Animated.View>
        )}
        <Loader
          loading={!!loading}
          className="absolute"
          iconProps={{ size: 48 }}
        />
      </DetailBlock>
    </>
  )
}
